import React, { useState } from "react";
import { withRouter, Redirect } from "react-router";
import { auth } from "./firebase";
import { signInWithEmailAndPassword } from "firebase/auth";
import { useAuth } from "./Auth";
import TopBanner from './TopBanner'
import Footer from './Footer'

const SignInForm = ({ history, icon }) => {
	const [ values, setValues] = useState({})

  	const logIn = async (event) => {
		event.preventDefault();
		const { email, password } = values ;
		try {
			await signInWithEmailAndPassword(auth, email, password);
			history.push("/app");
		} catch (error) {
			alert(error);
		}
	}

	const currentUser = useAuth();

	if (currentUser) {
		return <Redirect to="/app" />;
	}
	const handleChange = name => event => {
        setValues({ ...values, [name]: event.target.value });
    };

	return (
        <div>
			<div className="min-h-[60vh] flex items-center justify-center p-4">
				<div className="w-full max-w-sm bg-white dark:bg-gray-900 shadow-xl rounded-2xl p-6 border border-gray-100 dark:border-gray-800">
					<form onSubmit={(e) => { e.preventDefault(); logIn(e); }}>
						<div className="space-y-4">
							<div>
								<label className="text-xs font-medium text-gray-600 dark:text-gray-400 block mb-1.5">Email</label>
								<input
									id="email"
									type="email"
									placeholder="you@example.com"
									value={values.email || ''}
									onChange={handleChange('email')}
									className="border border-gray-300 dark:border-gray-700 focus:border-[#880e4f] rounded-xl px-4 py-2.5 w-full dark:bg-gray-950 text-sm transition-colors"
									autoComplete="email"
								/>
							</div>
							<div>
								<label className="text-xs font-medium text-gray-600 dark:text-gray-400 block mb-1.5">Password</label>
								<input
									id="password"
									type="password"
									placeholder="••••••••"
									value={values.password || ''}
									onChange={handleChange('password')}
									className="border border-gray-300 dark:border-gray-700 focus:border-[#880e4f] rounded-xl px-4 py-2.5 w-full dark:bg-gray-950 text-sm transition-colors"
									autoComplete="current-password"
								/>
							</div>
							<button 
								type="submit" 
								className="mt-2 w-full bg-[#880e4f] hover:bg-[#6b0b3f] active:bg-[#4a0835] text-white font-medium py-2.5 rounded-xl transition-all shadow-sm"
							>
								Log in
							</button>
						</div>
					</form>
					<p className="mt-5 text-xs text-center text-gray-500">
						Don't have an account? <a href="/signup" className="text-[#880e4f] hover:underline font-medium">Sign Up</a>
					</p>
				</div>
			</div>
			<Footer />
		</div>
    );
};

export default withRouter(SignInForm);